// VizModeToggle — the Bar | Map pill that swaps the allocation chart's view. Shared by the
// holdings chart and the model allocation modal so both read and behave the same.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BarIcon, MapIcon } from '../../../icons/Icons';
import { cx } from '../../../../utils/cx';
import './viz-mode-toggle.css';

export function VizModeToggle({ mode, onChange, className }) {
  const { t } = useTranslation();
  // The labels sit in their own span, and each tab carries the same text as an
  // aria-label: on a phone the words are hidden so the toggle stays compact, and an
  // icon-only tab still announces itself.
  return (
    <div className={cx('viz-toggle', className)} role="tablist" aria-label={t('portfolio.viz.modeAria')}>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'bar'}
        aria-label={t('portfolio.viz.bar')}
        className={cx(mode === 'bar' && 'is-active')}
        onClick={() => onChange('bar')}
      >
        <BarIcon /> <span className="viz-toggle__lbl">{t('portfolio.viz.bar')}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'map'}
        aria-label={t('portfolio.viz.map')}
        className={cx(mode === 'map' && 'is-active')}
        onClick={() => onChange('map')}
      >
        <MapIcon /> <span className="viz-toggle__lbl">{t('portfolio.viz.map')}</span>
      </button>
    </div>
  );
}

VizModeToggle.propTypes = {
  mode: PropTypes.oneOf(['bar', 'map']).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default VizModeToggle;
